import React from "react";
import { useEffect, useState } from "react";
import Page from "../../../components/Page";

import SubscriptionSectionComponent from "../../../components/NewDesign/SubscriptionPage/SubscriptionSectionComponent";
import Loader from "../../../components/Loader/Loader";
import {
  getActiveHeader,
  getActiveHeaderClear,
} from "../../../redux/home/actions";
import { useDispatch, useSelector } from "react-redux";
import HomePage from "../../HomePage";

const SubscriptionB2C = () => {
  const [isLoading, setIsLoading] = useState(false);
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const isMobile = params.get("isMobile");
  let dispatch = useDispatch();
  const authBroker = useSelector((state) => state.auth.authBroker);
  const userRole = useSelector((state) => state.user.role);

  useEffect(() => {
    window.scrollTo(0, 0);

    dispatch(getActiveHeader("subscription"));
  }, []);

  return (
    <>
      <Loader start={isLoading} />

      <Page>
        <SubscriptionSectionComponent
          fetchData={true}
          setMainPageLoading={setIsLoading}
          isMobile={isMobile}
        />

        {/* <section className="subscription-course-section">
          <div className="container">
            <div className="row">
              <div className="col-8">
                <div className="subscriptions-row">
                  <h3 className="subs-course-title">
                    Courses included with subscription
                  </h3>
                  <span className="subscriptions-subhead">
                    👍🏻 1,000+ learners have subscribed
                  </span>
                </div>
              </div>
              <div className="col-4"></div>
            </div>
          </div>
        </section> */}
      </Page>
    </>
  );
};
export default SubscriptionB2C;
